import { inject, Injector, runInInjectionContext } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState } from '@ngrx/signals';
import { tap } from 'rxjs';
import { GetCabinaGQL } from '../../_graphql/generated';

export const getCabina =
  (injector: Injector, store: any, getter: GetCabinaGQL) => () =>
    runInInjectionContext(injector, () => {
      return getter
        .fetch(
          {},
          {
            context: { headers: { 'x-hasura-role': 'anonymous' } },
            fetchPolicy: 'cache-first',
          },
        )
        .pipe(
          tap(() => patchState(store, { loading: true })),
          tapResponse({
            next: (res) => {
              patchState(store, {
                loading: false,
                lista: res.data?.energy_village_cabina,
                failure: undefined,
              });
            },
            error: (error) => {
              patchState(store, {
                loading: false,
                lista: [],
                failure: error,
              });
            },
          }),
        );
    });
